<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header"><div class="card-title">{{ cardTitle }}</div></div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />

    <form @submit.prevent="subimtData()">
      <!--begin::Body-->
      <div class="card-body">
        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">التصنيف:</label>
            <select v-model="category" class="form-control">
              <option :value="null">اختر التصنيف</option>
              <option v-for="(val, key) in questionCategories" :value="key" :key="key">{{ val }}</option>
            </select>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">السؤال - عربي:</label>
            <input type="text" v-model="question" class="form-control">
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">السؤال - إنجليزي:</label>
            <input type="text" v-model="questionEn" class="form-control english-input">
          </div>
        </div>

        <div class="row">
          <div class="col-12 mb-3">
            <label for="" class="form-label">الإجابة - عربي:</label>
            <textarea v-model="answer" class="form-control" rows="5"></textarea>
          </div>
        </div>

        <div class="row">
          <div class="col-12 mb-3">
            <label for="" class="form-label">الإجابة - إنجليزي:</label>
            <textarea v-model="answerEn" class="form-control english-input" rows="5"></textarea>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">ترتيب الظهور:</label>
            <input type="number" v-model="sortNum" class="form-control">
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">الحالة:</label>
            <select v-model="isActive" class="form-control">
              <option :value="true">نشط</option>
              <option :value="false">غير نشط</option>
            </select>
          </div>
        </div>
      </div>
      <!--end::Body-->
      <!--begin::Footer-->
      <div class="card-footer">
        <div class="row">
          <div class="col text-end">
            <button v-if="!formLoader" type="submit" class="btn btn-success">ارسل</button>
            <loader v-if="formLoader" />
          </div>
        </div>
      </div>
      <!--end::Footer-->
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import { toast } from '@/helpers/tools';

export default {
  name: 'QuestionsForm',
  props: {
    cardTitle: {
      type: String,
      default: 'إضافة'
    },
    dataRow: {
      type: Object,
      default: null,
    },
    questionCategories: {
      type: Object,
      default: null,
    },
  },
  data(){
    return {
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      question: '',
      questionEn: '',
      answer: '',
      answerEn: '',
      sortNum: 0,
      isActive: true,
      category: null,
    }
  },
  methods: {
    subimtData(){
      this.formLoader = true;
      this.hasError = false;
      this.hasSucess = false;
      
      if(
        !this.question || this.question.trim() == '' || !this.answer || this.answer.trim() == '' || 
        !this.questionEn || this.questionEn.trim() == '' || !this.answerEn || this.answerEn.trim() == ''
      ){
        this.message = 'كل الحقول مطلوبة';
        this.errorNumber = 0;
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
        return false;
      }
      let payload = {
        category: this.category,
        question: this.question,
        questionEn: this.questionEn,
        answer: this.answer,
        answerEn: this.answerEn,
        sortNum: this.sortNum,
        isActive: this.isActive,
      }
      let api = null;
      if(this.dataRow)
        api = this.$http.put(`/api/admin/questions/update/${this.dataRow.id}`, payload);
      else
        api = this.$http.post('/api/admin/questions/create', payload);
      api.then(({data}) => {
        if(!this.dataRow){
          toast('تم إضافة الإعداد بنجاح', 'success');
          this.$router.replace('/questions').catch(() => {});
        }else{
          this.message = 'تم التعديل بنجاح';
          this.hasSucess = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        this.formLoader = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
      });
    },
  },
  created(){
    if(this.dataRow){
      this.category = this.dataRow.category;
      this.question = this.dataRow.question;
      this.questionEn = this.dataRow.questionEn;
      this.answer = this.dataRow.answer;
      this.answerEn = this.dataRow.answerEn;
      this.sortNum = this.dataRow.sortNum;
      this.isActive = this.dataRow.isActive;
    }
  }
}
</script>
